
// App-wide authentication logic goes here.
import { selectors as memberSelectors } from '../main/member/reducer'

// App-wide authentication logic goes here.
export const isAuthenticated = () => {
  return memberSelectors.loggedIn(window.store.getState())
}
